module.exports = "/_next/static/images/Top200Workplaces-ecaf18489ed40a4bdc11f7e08e20d3af.png";